import cx from 'classnames';
import { type Ref } from 'react';
import { type Tab } from './TabList';
import styles from './TabList.module.css';

type TabItemProps<T> = {
  tab: Tab<T>;
  isActive: boolean;
  isBlueInactive: boolean;
  tabRef: Ref<HTMLLIElement>;
  onTabClick: (tab: Tab<T>) => void;
};

export default function TabItem<T>({ tab, isActive, isBlueInactive, tabRef, onTabClick }: TabItemProps<T>) {
  return (
    <li
      id={String(tab.id)}
      role="tab"
      data-testid={tab['data-testid']}
      ref={tabRef}
      style={tab.styles}
      onClick={() => {
        if (tab.isTabDisabled) return;
        onTabClick(tab);
      }}
      aria-disabled={tab.isTabDisabled ? true : undefined}
      className={cx(styles.tab, {
        [styles.active]: isActive,
        [styles.highlighted]: tab.isTabHighlighted,
        [styles.disabled]: tab.isTabDisabled,
        [styles.blueInactiveTab]: isBlueInactive,
      })}
    >
      {tab.label}
    </li>
  );
}
